import clsx from "clsx"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { Layout } from "../../../ui/layout"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import Button from "../../../ui/molecules/button"
import { Banner } from "../../../ui/organisms/banner"
import { ListM024Customer } from "./listM024Customer"
import { useState } from "react"
import { PopupForm } from "../../../ui/organisms/popupForm"
import { PopupTypeM024 } from "./popupType"

export function M024() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const [addPopupShow, setAddPopupShow] = useState<boolean>(false)

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Gestione Controllo', 'Elenco M024']}
            noPaddingLat
            headerLabel="Elenco M024"
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end" style={{ justifyContent: 'end' }}>
                    <Button size={"sm"} iconPosition={"off"} variant={"solid"} label="Crea nuovo" color={"orange"}
                        disabled={!sessionState.selected.customerId}
                        onClick={() => {
                            //navigate('/addPacDetail')
                            setAddPopupShow(true)
                        }}
                    />
                </div>
            }
        >
            <div style={{ padding: '12px 24px 0px 24px' }}>
                <ListM024Customer />
                {
                    addPopupShow && (
                        <PopupForm title="Scegli Tipologia M024" headerGreen={true} close={() => {
                            setAddPopupShow(false)
                        }}>
                            <PopupTypeM024 close={() => setAddPopupShow(false)} />
                        </PopupForm>
                    )
                }
            </div>

        </Layout>
    )

}